export default "__VITE_ASSET__CAJlGJGL__"